import * as React from 'react';
import { CustomTooltip } from '../CustomTooltip';
import { useClickController } from '../../internal';

/**
 * Компонент тултипа для онбординга
 *
 * @export
 * @param {IOnboardingTooltipProps} props
 * @returns
 */
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function OnboardingTooltip(props) {
  var _props$theme = props.theme,
    theme = _props$theme === void 0 ? 'blue' : _props$theme,
    children = props.children,
    content = props.content,
    _props$flip = props.flip,
    flip = _props$flip === void 0 ? true : _props$flip,
    header = props.header,
    placement = props.placement,
    portal = props.portal,
    portalElement = props.portalElement;
  var _useClickController = useClickController(props),
    childrenProps = _useClickController.childrenProps,
    childrenRef = _useClickController.childrenRef,
    open = _useClickController.open,
    handleClose = _useClickController.handleClose;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/React.cloneElement(children, childrenProps), /*#__PURE__*/_jsx(CustomTooltip, {
      header: header,
      content: content,
      open: open,
      anchorRef: childrenRef,
      placement: placement,
      theme: theme,
      portal: portal,
      portalElement: portalElement,
      arrow: true,
      flip: flip,
      preventOverflow: true,
      closeButton: true,
      minHeight: 56,
      maxWidth: 320,
      onClose: handleClose
    })]
  });
}